export default {
    persianDigit: (value) => {
        const persian = {
            0: '۰',
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹'
        }

        var result = value.toString()
        for (let i = 0; i <= 9; i++) {
            result = result.replace(new RegExp(`${i}`, 'g'), persian[i])
        }
        return result;
    },
    commaDigit: (value) => {
        //console.log({commaDigit:(value+ " ").replace(/\B(?=(\d{3})+(?!\d))/g, ",")});
        return (value + " ").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}